/**
 * Card Atom
 *
 * Container card reutilizável
 */
import React from 'react'

export default function Card({
	children,
	title,
	subtitle,
	action,
	padding = true,
	className = '',
	...props
}) {
	return (
		<div
			className={`bg-base-300 rounded-xl border border-base-200 shadow-sm ${className}`}
			{...props}
		>
			{(title || action) && (
				<div className="flex items-center justify-between px-6 py-4 border-b border-base-200">
					<div>
						{title && (
							<h3 className="text-lg font-semibold text-text">{title}</h3>
						)}
						{subtitle && (
							<p className="text-sm text-text-body mt-0.5">{subtitle}</p>
						)}
					</div>
					{action && (
						<div>{action}</div>
					)}
				</div>
			)}
			<div className={padding ? 'p-6' : ''}>
				{children}
			</div>
		</div>
	)
}
